<template>
  <div class="sb_gallery">
    <Wrapper>
      <span class="sb_gallery_info">Klik op een afbeelding op het canvas om deze toe te voegen aan jouw ontwerp.</span>
    </Wrapper>
    <div class="sb_gallery_images" v-if="images.length">
      <div class="sb_gallery_image_wrapper" v-for="(image, i) in images" :key="`background-image-${i}`">
        <button
          :style="{ transform: `translate(${image.x}px, ${image.y}px)`, width: image.width, height: image.height }"
          :class="{
            s_active: type == 'image' ? activeImages.includes(`${type}-${i}`) : activeBackground === `${type}-${i}`,
          }"
          :disabled="!!loading"
          class="sb_gallery_image"
          ref="images"
        >
          <img
            :src="image.thumbnail"
            draggable="true"
            @click="addItem(image)"
            @dragstart="initiateDrag($event, image)"
            width="100%"
            height="100%"
          />
        </button>
        <transition name="fade">
          <span v-if="image.loading || image.preLoading" class="sb_gallery_image_loader">
            <span class="sb_gallery_image_loader_wrapper">
              <Spinner class="sb_gallery_image_loader_spinner" />
              <SvgIcon
                v-if="!image.preLoading"
                class="sb_gallery_image_loader_cancel"
                @click.native="$emit('update:loading', false)"
                icon="close"
              />
            </span>
          </span>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    images: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      default: 'image',
    },
    loading: {
      type: [String, Boolean],
      default: false,
    },
  },
  data() {
    return {
      IMAGES_MAX_COUNT: this.$root.imagesMaxCount,
    };
  },
  async mounted() {
    await this.$nextTick();

    if (this.images.length) {
      this.preloadImages();
    }
  },
  watch: {
    images(newList, oldList) {
      if (newList.length > oldList.length) {
        this.preloadImages();
      }
    },
  },
  methods: {
    addItem(image) {
      const src = image.medium;
      const id = image.id;
      const original = image.original;
      this.$emit('addItem', { src, id, original });
    },
    initiateDrag(e, image) {
      const type = this.type.charAt(0).toUpperCase() + this.type.substring(1);
      e.dataTransfer.setData('type', type);
      e.dataTransfer.setData('image', JSON.stringify(image));
      e.dataTransfer.setData('id', image.id);
    },
    preloadImages() {
      this.images.forEach((image) => {
        image.preLoading = true;
        this.loadImage(image);
      });

      this.$emit('update:images', [].concat(this.images));
    },
    loadImage(image) {
      const preload = new Image();
      preload.onload = () => {
        image.preLoading = false;
        this.$emit('update:images', [].concat(this.images));
      };
      preload.src = image.thumbnail;
    },
  },
  computed: {
    ...mapState('design', {
      activeImages: (state) => {
        return state.images;
      },
      activeBackground: (state) => {
        return state.background;
      },
    }),
  },
};
</script>

<style lang="scss">
#sb_fotowand-designer {
  .sb_gallery {
    &_info {
      line-height: 1.8;
      font-size: 0.65rem;
      font-weight: 500;
      color: rgba($brand-dark-gray, 0.6);
      letter-spacing: 0.75px;
      font-family: InterGX, Inter, sans-serif;
      @include media('>=medium') {
        font-size: 0.75rem;
      }
    }
    &_images {
      margin-top: 1rem;
      display: flex;
      flex-wrap: wrap;
    }
    &_image {
      width: 100%;
      height: 100%;
      border-radius: $default-radius / 1.5;
      border: 0px solid transparent;
      padding: 0;
      transition: border 0.4s, padding 0.4s;
      &_loader {
        pointer-events: all;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 2.4rem;
        padding-top: 0.4rem;
        color: $brand-primary;
        background: rgba($brand-white, 0.6);
        &_spinner {
          transition: opacity 0.4s;
        }
        &_cancel {
          position: absolute;
          top: 0;
          z-index: 9;
          right: 0;
          color: $brand-red;
          background: $brand-white;
          box-shadow: 0 0 2px 0 rgba($brand-black, 0.2);
          border-radius: 100%;
          padding: 0.4rem;
          transform: translate(30%, -30%);
          font-size: 1rem;
          transition: color 0.4s;
          cursor: pointer;
          will-change: transform;
          &:hover {
            color: rgba($brand-red, 0.6);
          }
        }
      }
      &_wrapper {
        position: relative;
        display: inline-block;
        border: none;
        background: none;
        width: 50%;
        height: 6rem;
        padding: 0;
        padding-top: 0.4rem;
        &:nth-of-type(2n + 1) {
          padding-right: 0.8rem;

          .sb_gallery_image_loader {
            padding-right: 0.8rem;
            &_cancel {
              margin-right: 0.8rem;
            }
          }
        }
        @include media('>=small') {
          height: 8rem;
        }
        @include media('>=medium') {
          height: 7.5rem;
        }
        @include media('>=large') {
          height: 8rem;
        }
      }
      & img {
        object-fit: cover;
        border-radius: $default-radius;
        height: 100%;
        width: 100%;
      }
      &:hover,
      &.s_active {
        cursor: pointer;
        padding: 0.4rem;
        border: 3px solid $brand-secondary;
      }
      &.s_active {
        border: 3px solid $brand-primary;
      }
    }
  }
}
</style>
